<template>
  <div class="grid grid-cols-2 lg:grid-cols-4 gap-3 mb-4" data-testid="decisions-kpi-strip">
    <article
      v-for="card in cards"
      :key="card.id"
      class="decisions-kpi-card bg-white rounded-[10px] p-3 shadow-sm border border-[#E5E5E5]"
      :data-testid="`decisions-kpi-${card.id}`"
    >
      <div class="flex items-center gap-1.5 mb-1">
        <span class="w-2 h-2 rounded-full shrink-0" :style="{ backgroundColor: card.color }" />
        <p class="text-[10px] uppercase tracking-wider text-[var(--color-disabled)] font-medium m-0">
          {{ card.label }}
        </p>
      </div>
      <p class="text-[20px] font-bold text-[var(--color-dark)] leading-tight m-0">{{ card.value }}</p>
      <p class="text-[11px] text-[var(--color-disabled)] mt-0.5 mb-0">{{ card.subtitle }}</p>
    </article>
  </div>
</template>

<script>
import { computeDecisionKpis } from '@/utils/decisionDisplay';

export default {
  name: 'DecisionKpiStrip',
  props: {
    decisions: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    kpis() {
      return computeDecisionKpis(this.decisions);
    },
    cards() {
      const kpis = this.kpis;
      return [
        {
          id: 'duration',
          color: 'var(--color-warning-text)',
          label: this.$t('UserProjects.decisions.kpi.avgDuration'),
          value: kpis.avgDurationDays !== null
            ? `${kpis.avgDurationDays} ${this.$t('UserProjects.decisions.kpi.daysSuffix')}`
            : '—',
          subtitle: this.$t('UserProjects.decisions.kpi.avgDurationHint'),
        },
        {
          id: 'overdue',
          color: 'var(--color-error-text)',
          label: this.$t('UserProjects.decisions.kpi.overdue'),
          value: String(kpis.overdueCount),
          subtitle: this.$t('UserProjects.decisions.kpi.overdueHint', { total: kpis.pendingCount }),
        },
        {
          id: 'escalated',
          color: 'var(--color-error-text)',
          label: this.$t('UserProjects.decisions.kpi.escalatedShare'),
          value: `${kpis.escalatedPercent}%`,
          subtitle: this.$t('UserProjects.decisions.kpi.escalatedHint', {
            count: kpis.escalatedCount,
            total: kpis.pendingCount,
          }),
        },
        {
          id: 'backlog',
          color: 'var(--color-warning-text)',
          label: this.$t('UserProjects.decisions.kpi.backlog'),
          value: `${kpis.openCount} ${this.$t('UserProjects.decisions.kpi.openSuffix')}`,
          subtitle: this.$t('UserProjects.decisions.kpi.backlogHint', { prepared: kpis.preparedCount }),
        },
      ];
    },
  },
};
</script>
